var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 0H1.42858C0.63959 0 6.24417e-06 0.639583 6.24417e-06 1.42857V18.5714C-0.000886613 18.8716 0.0939943 19.1642 0.270959 19.4067C0.539173 19.7789 0.969828 19.9996 1.42858 20H27.1429C27.601 19.9997 28.0311 19.7798 28.2995 19.4086C28.4769 19.1655 28.5722 18.8723 28.5714 18.5714V1.42857C28.5714 0.639583 27.9319 0 27.1429 0ZM0.952387 18.2986V3.13143L10.7691 10.7143L0.952387 18.2986ZM1.54048 19.0476L11.5476 11.3162L13.4129 12.7562C13.9271 13.1531 14.6444 13.1531 15.1586 12.7562L17.0238 11.3162L27.031 19.0476H1.54048ZM27.6191 18.2986L17.8024 10.7143L27.6191 3.13143V18.2986ZM27.6191 1.9281L14.5767 12.0024C14.4052 12.1347 14.1662 12.1347 13.9948 12.0024L0.952387 1.9281V1.42857C0.952387 1.1656 1.1656 0.952381 1.42858 0.952381H27.1429C27.4058 0.952381 27.6191 1.1656 27.6191 1.42857V1.9281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.a409cfa20df3e40c1dc68e79050d9807.svg";
export { ForwardRef as ReactComponent };